export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.064.023c1.1 0 1.992.923 1.992 2.061s-.892 2.061-1.992 2.061C.963 4.145.07 3.222.07 2.085.07.945.963.022 2.064.022zm5.978 0c1.1 0 1.993.923 1.993 2.061s-.892 2.061-1.993 2.061c-1.1 0-1.993-.923-1.993-2.06C6.05.945 6.941.022 8.042.022zm7.971 2.061c0-1.138-.892-2.06-1.993-2.06-1.1 0-1.992.922-1.992 2.06s.892 2.061 1.992 2.061 1.993-.923 1.993-2.06z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "17",
    "height": "5",
    "viewBox": "0 0 17 5",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};